import { PersonaRequestBody } from './PersonaRequestBody';

/**
 * @public
 */
export interface GetModelFilterSearchResultRequestBody
  extends PersonaRequestBody {
  Models: string;
}
